import xss from 'xss';

const DIALOG_TYPE_MESSAGE = '#DIALOG_TYPE_MESSAGE';
const DIALOG_TYPE_CONFIRM = '#DIALOG_TYPE_CONFIRM';
const POPUP_TYPE_LAYER = '#POPUP_TYPE_LAYER';
// const POPUP_TYPE_WINDOW = '#POPUP_TYPE_WINDOW';

const DIALOG_SELECTION_OK = 'ok';
const DIALOG_SELECTION_CANCEL = 'cancel';

// const dialogMap = new Map();
const popupMap = new Map();
// const windowMap = new Map();
const handlerMap = new Map();

// function unloadHandler(event) {
//     event.currentTarget.removeEventListener('unload', unloadHandler);
//
//     popupMap.forEach((value, key, map) => {
//         if (value === event.currentTarget) {
//             map.delete(key);
//         }
//     });
//
//     if (callbackMap.has(event.currentTarget)) {
//         const callback = callbackMap.get(event.currentTarget);
//         callback();
//     }
// }
//
// function openAsWindow(url, parameters, closeHandler) {
//     if (popupMap.has(url)) {
//         throw new Error('The url is already opened as popup.');
//     }
//
//     const uid = _.uniqueId();
//     const popup = window.open(url, uid, 'width=1140,height=600,scrollbars=no');
//     if (popup) {
//         popupMap.set(url, popup);
//
//         if (closeHandler !== 'undefined') {
//             callbackMap.set(popup, closeHandler);
//         }
//
//         if (parameters) {
//             popup.postMessage(parameters, getContextRoot());
//         }
//
//         popup.addEventListener('unload', unloadHandler, false);
//         popup.addEventListener('message', () => {
//         }, false);
//     }
// }
// function messageHandler(event) {
//     const data = JSON.parse(event.data);
//     const handler = handlerMap.get(data.name);
//     if (handler !== 'undefined') {
//         handler(data.parameters);
//     }
//
//     handlerMap.delete(data.name);
//     // top.window.removeEventListener('message', messageHandler);
// }
//
// function sendMessage(name, parameters) {
//     const data = {
//         name,
//         parameters,
//     };
//
//     top.window.postMessage(JSON.stringify(data), window.location.origin);
// }
//
// function receiveMessage(name, handler) {
//     handlerMap.set(name, handler);
// }

//-------------------------------------
// Dialog
//-------------------------------------

function createDialog(name, type) {
    let t;
    switch (type) {
    case 'confirm':
        t = DIALOG_TYPE_CONFIRM;
        break;
    default:
        t = DIALOG_TYPE_MESSAGE;
    }

    const element = $(top.document).find(t).clone();
    $(element).attr('id', name);
    $('body').append(element);

    const dialog = $plugin.popmodal(element);
    // dialogMap.set(name, dialog);
    return dialog;
}

// function hasDialog(name) {
//     return dialogMap.has(name);
// }

// function getDialog(name) {
//     return dialogMap.get(name);
// }

function closeDialog(name, selection, closeHandler = undefined) {
    const dialog = this;

    if (closeHandler !== undefined) {
        closeHandler.call(dialog, selection);
    }

    dialog.closeOutput();
    $(dialog).remove();

    // dialogMap.delete(type);
}

function openDialog(type = 'message', content = undefined, closeHandler = undefined) {
    const name = `${type}_${_.uniqueId()}`;
    const dialog = createDialog(name, type);
    const dialogContent = $(dialog).find('.content');

    if (content !== undefined) {
        $(dialogContent).children().remove();
        $(dialogContent).append(`<p>${xss(content)}</p>`);

        if (_.isEqual(type, 'message')) {
            $(dialog).find('.btn-com, .ui-close').click($.proxy(closeDialog, dialog, name, { selection: DIALOG_SELECTION_OK }, closeHandler));
        } else if (_.isEqual(type, 'confirm')) {
            $(dialog).find('.btn-com.c1').click($.proxy(closeDialog, dialog, name, { selection: DIALOG_SELECTION_OK }, closeHandler));
            $(dialog).find('.btn-com.c2, .ui-close').click($.proxy(closeDialog, dialog, name, { selection: DIALOG_SELECTION_CANCEL }, closeHandler));
        }
    }

    dialog.openOutput();
    // temp
    $(dialog).css('z-index', 99999);
}

//-------------------------------------
// Popup
//-------------------------------------

function createPopup(name, option) {
    const element = $(top.document).find(POPUP_TYPE_LAYER).clone();
    $(element).attr('id', name);
    $('body').append(element);
    const popup = $plugin.popmodal(element, option);
    popupMap.set(name, popup);
    return popup;
}

function hasPopup(name) {
    return popupMap.has(name);
}

function getPopup(name) {
    return popupMap.get(name);
}

function closePopup(name, parameters = undefined) {
    const popup = getPopup(name);
    // const popupFrame = $(popup).find('#popupFrame');
    // const popupWindow = popupFrame[0].contentWindow;
    // popupWindow.removeEventListener('message', messageHandler);

    // if (parameters !== undefined) {
    // sendMessage(name, parameters);
    if (handlerMap.has(name)) {
        handlerMap.get(name).call(popup, parameters);
        handlerMap.delete(name);
    }
    // }
    popupMap.delete(name);
    popup.closeOutput();
    $(popup).find('#popupFrame').remove();
    $(popup).remove();
}

function openPopup(name, url, parameters = undefined, closeHandler = undefined) {
    let popup;
    const option = {};

    // const popupFrame = $(popup).find('#popupFrame');
    // const popupWindow = popupFrame[0].contentWindow;
    // $(popupWindow).on('message', messageHandler);
    // popupWindow.addEventListener('message', messageHandler, false);
    // top.window.addEventListener('message', messageHandler, false);

    let src = url;
    if (parameters !== undefined && parameters !== null) {
        src += (src.indexOf('?') > -1) ? '&' : '?';

        const paramArray = [];
        const keys = Object.keys(parameters);

        $(keys).each((i) => {
            const key = keys[i];
            const value = encodeURIComponent(parameters[key]);
            paramArray.push(`${key}=${value}`);
            if (_.isEqual(key, 'size_width')) {
                option.size_width = parameters[key];
            }
            if (_.isEqual(key, 'size_height')) {
                option.size_height = parameters[key];
            }
        });
        src += _.join(paramArray, '&');
    }

    if (closeHandler !== undefined) {
        // receiveMessage(name, closeHandler);
        handlerMap.set(name, closeHandler);
    }

    if (hasPopup(name)) {
        popup = getPopup(name);
    } else {
        popup = createPopup(name, option);
        $('.ui-close').click($.proxy(closePopup, null, name, null));
    }

    const popupFrame = $(popup).find('#popupFrame');
    $(popupFrame).attr('src', xss(src));
    popup.openOutput();
}

//-------------------------------------
// Window
//-------------------------------------

// function closeWindow() {
//     // do stuff
// }
//
// function openWindow() {
//     // do stuff
// }

export {
    openDialog,
    hasPopup, getPopup,
    openPopup, closePopup,
    // openWindow, closeWindow,
};



// WEBPACK FOOTER //
// ./src/utils/ec-popup.js